import React from "react";
import Button from "Components/button/Button";
import t from "Utils/translation";
import WarningBanner from "Components/warningBanner/WarningBanner";
import PlanSelector from "Components/planSelector/PlanSelector";
import Select from "Components/select/Select";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";
import TranslatedString from "Components/TranslatedString";
import { Icon, antimalware, exchangeColor } from "Icons/index";
import cx from "classnames";

const PLANS_FEATURES = {
  basic: ["feature.mailServices", "feature.webmail", "feature.mailboxSize", "feature.antivirus"],
  professional: ["feature.basic", "feature.sharedCalendars", "feature.mailboxSize50", "feature.antimalware"],
  enterprise: [
    "feature.basic",
    "feature.sharedCalendars",
    "feature.mailboxSize100",
    "feature.antimalware",
    "feature.exchange",
  ],
};

const NewTag = () => (
  <div className="px-1 text-[10px] text-white uppercase rounded-full bg-qb-green leading-[100%] h-[16px] flex items-center">
    New
  </div>
);

export default class BasicForm extends React.Component {
  state = {};

  componentDidMount() {
    if (this.props.loggedUser.ordered_domains) {
      let selectedDomain = this.props.loggedUser.ordered_domains[0];
      this.props.setFormFieldValue({ ...selectedDomain });
    }
  }

  goToNextStep = (e) => {
    e.preventDefault();
    const { setFormLoading, setDataForm, goToStep } = this.props;

    if (!this.props.formData.plan) {
      console.log("debug formdata", this.props.formData);
      this.props.setFormErrors({ onForm: t("errorMsg.planRequired") });
      return false;
    }

    if (!this.validatePayment()) {
      window.alert("Per attivare questo dominio devi prima pagare la fattura");
      return false;
    }

    setFormLoading();

    setDataForm(this.state.formData);
    goToStep(2);
  };

  validatePayment = () => {
    if (!this.props.loggedUser.ordered_domains) return true;
    const ordered_domains = Array.from(this.props.loggedUser.ordered_domains);

    let hasPaid = true;

    this.props.loggedUser.orders.forEach((o) => {
      if (this.props.formData.order_id === o.id && o.status !== "paid") {
        hasPaid = false;
      }
    });

    return hasPaid;
  };

  selectedOrderedDomain = (val) => {
    let selectedDomain = this.props.loggedUser.ordered_domains.filter((d) => d.name === val.name)[0];

    this.props.setFormFieldValue({ ...selectedDomain });
  };

  render() {
    const { formData, setFormFieldValue, formErrors, isFormLoading, loggedUser } = this.props;

    const noOrderedDomains = loggedUser.ordered_domains && loggedUser.ordered_domains.length === 0;
    return (
      <div className="formsPage">
        {this.props.stepper}

        <div className={cx("sectionTitle", "titleFP")}>{t("domains.add.title.step1")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">{t("domains.add.desc.step1")}</div>
            <Button className="btnDocsFP" docsKey="domains_add" color="docs" sizeSmall>
              button.docs
            </Button>
          </div>

          <form className="wrapFormsFP">
            <div className="formsFP">
              {noOrderedDomains && (
                <WarningBanner color="red" msg={<TranslatedString>errorMsg.notAvailable.domains</TranslatedString>} />
              )}

              {loggedUser.ordered_domains && (
                <Select
                  label={t("input.label.domain")}
                  components={{ DropdownIndicator }}
                  className="inputFull2"
                  name="name"
                  options={loggedUser.ordered_domains.map((d) => ({
                    value: d.name,
                    label: d.name,
                  }))}
                  value={formData.name}
                  onChange={this.selectedOrderedDomain}
                  disabled={noOrderedDomains}
                />
              )}

              <PlanSelector
                className={"inputFull2"}
                grouplabel={t("input.label.select.plan")}
                children={[
                  {
                    value: "basic",
                    label: t("plan.basic.name"),
                    description: t("plan.basic.desc"),
                    subcomponent: (
                      <div className="w-full px-4 py-2 rounded bg-[--accent-l35] mb-6">
                        <div className="mb-2 text-xs uppercase opacity-60">Alcune funzionalità incluse</div>

                        <ul className="flex flex-col pl-4 text-sm md:grid md:grid-cols-2 gap-y-2">
                          {PLANS_FEATURES.basic.map((feature) => (
                            <li className="flex items-center gap-2" key={feature}>
                              <div className="rounded-full bg-qb-blue h-[6px] w-[6px]"></div>

                              <div className="flex items-center gap-1">
                                <div className="opacity-60">
                                  <TranslatedString>{feature}</TranslatedString>
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ),
                  },
                  {
                    value: "professional",
                    label: t("plan.professional.name"),
                    description: t("plan.professional.desc"),
                    bestLabel: t("plan.professional.bestLabel"),
                    subcomponent: (
                      <div className="w-full px-4 py-2 rounded bg-[--accent-l35] mb-6">
                        <div className="mb-2 text-xs uppercase opacity-60">Alcune funzionalità incluse</div>

                        <ul className="flex flex-col pl-4 text-sm md:grid md:grid-cols-2 gap-y-2">
                          {PLANS_FEATURES.professional.map((feature) => (
                            <li className="flex items-center gap-2" key={feature}>
                              <div className="rounded-full bg-qb-blue h-[6px] w-[6px]"></div>

                              <div className="flex items-center gap-1">
                                {feature === "feature.antimalware" && (
                                  <>
                                    <Icon svg={antimalware} width="0.75rem" height="0.75rem" />
                                  </>
                                )}

                                <div className="opacity-60">
                                  <TranslatedString>{feature}</TranslatedString>
                                </div>

                                {feature === "feature.antimalware" && <NewTag />}
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ),
                  },
                  {
                    value: "enterprise",
                    label: t("plan.enterprise.name"),
                    description: t("plan.enterprise.desc"),
                    subcomponent: (
                      <div className="w-full px-4 py-2 rounded bg-[--accent-l35]">
                        <div className="mb-2 text-xs uppercase opacity-60">Alcune funzionalità incluse</div>

                        <ul className="flex flex-col pl-4 text-sm md:grid md:grid-cols-2 gap-y-2">
                          {PLANS_FEATURES.enterprise.map((feature) => (
                            <li
                              className={cx({
                                "flex items-center gap-2": true,
                                "col-span-2": feature === "feature.exchange",
                              })}
                              key={feature}
                            >
                              <div className="rounded-full bg-qb-blue h-[6px] w-[6px]"></div>

                              <div className="flex items-center gap-1">
                                {feature === "feature.antimalware" && (
                                  <>
                                    <Icon svg={antimalware} width="0.75rem" height="0.75rem" />
                                  </>
                                )}

                                {feature === "feature.exchange" && (
                                  <>
                                    <Icon svg={exchangeColor} width="0.75rem" height="0.75rem" />
                                  </>
                                )}

                                <div className="opacity-60">
                                  <TranslatedString>{feature}</TranslatedString>
                                </div>

                                {feature === "feature.antimalware" && <NewTag />}
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ),
                  },
                ]}
                name="plan"
                disabled={loggedUser.ordered_domains}
                value={formData.plan}
                onChange={setFormFieldValue}
              />
            </div>

            {formErrors.onForm && (
              <div className="warningMsgFP">
                <WarningBanner color="red" msg={formErrors.onForm} />
              </div>
            )}

            <div className="footerFP">
              <Button color="text" type="button" onClick={this.props.backToList}>
                button.cancel
              </Button>
              <Button color="accent" disabled={noOrderedDomains} loading={isFormLoading} onClick={this.goToNextStep}>
                button.continue
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
